import { render, staticRenderFns } from "./TermsIndex.vue?vue&type=template&id=dcc7ca04&scoped=true"
import script from "./TermsIndex.vue?vue&type=script&lang=js"
export * from "./TermsIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcc7ca04",
  null
  
)

export default component.exports